import { Pipe, PipeTransform } from '@angular/core';

import { IBomModel } from '../../prisma-xs/models/bom.model';

@Pipe({
    name: 'filterOutSelectedItems',
    standalone: false
})
export class FilterOutSelectedItemsPipe implements PipeTransform {
  transform(bomModels: IBomModel[], selectedItems: number[], attribute: string): IBomModel[] {
    return bomModels?.filter(b => selectedItems.includes(b.article[attribute]));
  }
}
